import { Link } from "react-router-dom";
import { MapPin, Phone, Envelope, Clock, FacebookLogo, InstagramLogo } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0D2C54] text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-[#E63946] flex items-center justify-center">
                <span className="font-display font-bold text-lg">M</span>
              </div>
              <div>
                <div className="font-display font-bold text-xl">MECA AUTO 17</div>
                <div className="overline text-[10px] text-white/60">Tonnay-Charente</div>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Garage automobile de confiance à Tonnay-Charente (17430). Entretien, réparation et diagnostic toutes marques par des experts qualifiés.
            </p>
          </div>

          <div>
            <h4 className="overline mb-6 text-white/60">Navigation</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-[#E63946] transition-colors">Accueil</Link></li>
              <li><Link to="/services" className="hover:text-[#E63946] transition-colors">Nos services</Link></li>
              <li><Link to="/equipe" className="hover:text-[#E63946] transition-colors">L'équipe</Link></li>
              <li><Link to="/actualites" className="hover:text-[#E63946] transition-colors">Actualités</Link></li>
              <li><Link to="/rendez-vous" className="hover:text-[#E63946] transition-colors">Prendre rendez-vous</Link></li>
              <li><Link to="/devis" className="hover:text-[#E63946] transition-colors">Demander un devis</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="overline mb-6 text-white/60">Coordonnées</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex gap-3"><MapPin size={20} className="text-[#E63946] shrink-0 mt-0.5" /><span>49 Av. Charles de Gaulle<br />17430 Tonnay-Charente</span></li>
              <li className="flex gap-3"><Phone size={20} className="text-[#E63946] shrink-0 mt-0.5" /><a data-testid="footer-phone" href="tel:+33546887088" className="hover:text-[#E63946]">05 46 88 70 88</a></li>
              <li className="flex gap-3"><Envelope size={20} className="text-[#E63946] shrink-0 mt-0.5" /><a href="mailto:mecaauto17@gmail.com" className="hover:text-[#E63946]">mecaauto17@gmail.com</a></li>
            </ul>
          </div>

          <div>
            <h4 className="overline mb-6 text-white/60">Horaires</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex justify-between gap-4"><span className="text-white/60">Lundi - Vendredi</span><span>8h - 18h30</span></li>
              <li className="flex justify-between gap-4"><span className="text-white/60">Samedi</span><span>9h - 17h</span></li>
              <li className="flex justify-between gap-4"><span className="text-white/60">Dimanche</span><span className="text-[#E63946]">Fermé</span></li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a href="#" aria-label="Facebook" className="w-10 h-10 border border-white/20 hover:border-[#E63946] hover:text-[#E63946] flex items-center justify-center transition-colors"><FacebookLogo size={18} /></a>
              <a href="#" aria-label="Instagram" className="w-10 h-10 border border-white/20 hover:border-[#E63946] hover:text-[#E63946] flex items-center justify-center transition-colors"><InstagramLogo size={18} /></a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} MECA AUTO 17 — Tonnay-Charente. Tous droits réservés.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Mentions légales</a>
            <a href="#" className="hover:text-white">Politique de confidentialité</a>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">Espace admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
